var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 6.16668C5.72257 6.16668 5.4987 6.39055 5.4987 6.66668C5.4987 6.9428 5.72257 7.16668 5.9987 7.16668C6.27482 7.16668 6.4987 6.9428 6.4987 6.66668C6.4987 6.39055 6.27482 6.16668 5.9987 6.16668ZM12.6654 1.33334H3.33203C2.22795 1.33456 1.33325 2.22926 1.33203 3.33334V10C1.33325 11.1041 2.22795 11.9988 3.33203 12H11.5274L14.0964 14.569C14.1589 14.6316 14.2436 14.6667 14.332 14.6667C14.5161 14.6667 14.6654 14.5174 14.6654 14.3333V3.33334C14.6641 2.22926 13.7694 1.33456 12.6654 1.33334ZM13.9987 13.5287L11.901 11.431C11.8385 11.3685 11.7538 11.3333 11.6654 11.3333H3.33203C2.59603 11.3324 1.99963 10.736 1.9987 10V3.33334C1.99963 2.59734 2.59603 2.00095 3.33203 2.00001H12.6654C13.4014 2.00095 13.9978 2.59734 13.9987 3.33334V13.5287ZM7.9987 6.16668C7.72257 6.16668 7.4987 6.39055 7.4987 6.66668C7.4987 6.9428 7.72257 7.16668 7.9987 7.16668C8.27482 7.16668 8.4987 6.9428 8.4987 6.66668C8.4987 6.39055 8.27482 6.16668 7.9987 6.16668ZM9.9987 6.16668C9.72257 6.16668 9.4987 6.39055 9.4987 6.66668C9.4987 6.9428 9.72257 7.16668 9.9987 7.16668C10.2748 7.16668 10.4987 6.9428 10.4987 6.66668C10.4987 6.39055 10.2748 6.16668 9.9987 6.16668Z",
    fill: "#398D94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.5fa39cfe.svg";
export { ForwardRef as ReactComponent };